import { useMemo } from "react";
import { DateTimeFormatStyle, useI18nContext } from "@hopper-b2b/i18n";
import dayjs from "dayjs";
import type { HotelReservationCardComponentProps } from "./HotelReservationCard";

const DATE_FORMAT = DateTimeFormatStyle.ShortMonthDayShortWeekday;

export const useHotelReservationCard = ({
  reservation,
  selectItinerary,
}: HotelReservationCardComponentProps) => {
  const { t, formatDateTime } = useI18nContext();

  return useMemo(
    () => ({
      context: {
        checkInDate: reservation.checkInDate,
        checkOutDate: reservation.checkOutDate,
      },
      handlers: {
        selectItinerary,
      },
      text: {
        product: t("core-hotels.postBooking.product"),
        title: reservation.lodgingSummary?.name ?? "",
        location: t("core-hotels.postBooking.summaryCard.location", {
          city: reservation.lodgingSummary?.city,
          country: reservation.lodgingSummary?.country,
        }),
        dates: t("core-hotels.postBooking.summaryCard.dates", {
          fromDate: formatDateTime(
            dayjs(reservation.checkInDate).toDate(),
            DATE_FORMAT
          ),
          untilDate: formatDateTime(
            dayjs(reservation.checkOutDate).toDate(),
            DATE_FORMAT
          ),
        }),
        confirmation: t("core-hotels.postBooking.summaryCard.confirmation", {
          reservationId: reservation.reservationId,
        }),
      },
    }),
    [reservation]
  );
};
